module.exports = __webpack_public_path__ + "assets/expand-cfcf2ed78a270458ddf5efce07e1e9ad.svg";